

























































































import { Dropzone } from 'dropzone'
import { Modal } from 'bootstrap'
import base_service from '../../services/base'

export default {
  name: '',
  data: -> {
    header: 'Price upload',
    columns: [ 'created at', 'branch', 'type', 'status'],
    price_imports: [],
    upload_error: null,
    dropzone: null,
    poll_id: 0,
    schemas_modal: null,
    schemas_import: null,
    import_schemas: null
  },
  props: [],

  created: ->
    @fetch_imports()
    @poll_imports()

  methods: {
    download_url: (id) ->
      "#{ base_service.api_endpoint() }/api/imports/#{ id }/download"

    fetch_imports: (options={}) ->
      fetch "#{ base_service.api_endpoint() }/imports", { headers: { 'http-x-auth': @$store.state.user.id } }
      .then (response) -> response.json()
      .then (imports) => @price_imports = imports
      .finally =>
        return if options.poll == undefined
        @poll_imports()

    poll_imports: ->
      @poll_id = setTimeout =>
        @fetch_imports({ poll: true })
      , 3000

    import_status: (price_import) ->
      if price_import.error_message.length > 0 then price_import.error_message else price_import.status

    schema_not_found: (price_import) ->
      price_import.status == 'failed' && price_import.error_message.includes('schema not found')

    open_schemas: (price_import) ->
      @schemas_import = price_import
      @import_schemas = null
      @schemas_modal.show()
      fetch "#{ base_service.api_endpoint() }/import_schemas", { headers: base_service.authenticated_json() }
      .then (response) -> response.json()
      .then (import_schemas) => @import_schemas = import_schemas

    schema_fields: (import_schema) ->
      Object.entries(import_schema.data)
      .map ([name, field]) -> { name: name, ...field }
      .sort (a, b) -> a.position - b.position

    column_letter: (position) ->
      letters = ''
      number = position + 1
      while number > 0
        letters = String.fromCharCode(65 + (number - 1) % 26) + letters
        number = Math.floor((number - 1) / 26)
      letters

    format_label: (format) ->
      switch format
        when 'barcode' then 'Barcode or code'
        when 'big_decimal' then 'Number'
        when 'stock_integer' then 'Whole number'
        when 'date_time' then 'Date (MM/DD/YYYY or YYYY/MM/DD)'
        else 'Text'

    status_class: (status) ->
      switch status
        when 'importing', 'publishing' then 'yellow'
        when 'completed' then 'green'
        when 'failed' then 'red'
  }

  mounted: ->
    @schemas_modal = new Modal(@$refs['schemas_modal'], {})

    @dropzone = new Dropzone @$refs['price_import_upload'], {
      url: "#{base_service.api_endpoint()}/imports",
      headers: { 'http-x-auth': @$store.state.user.id }
    }

    @dropzone.on 'complete', (file) =>
      response = JSON.parse(file.xhr.response)
      if response.status == 'error'
        @upload_error = "#{ file.name }:\n#{ response.message }"
      else @fetch_imports()

    @dropzone.on 'addedfile', =>
      @upload_error = null

  watch: {}

  destroyed: ->
    clearTimeout(@poll_id)
    @poll_id = 0
    @schemas_modal.dispose()
}
